module.exports = __webpack_public_path__ + "static/media/DSCF9623-2.80c328e6.jpg";